module.exports = __webpack_public_path__ + "static/img/zeta_template_12.adf24a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_12.png
// module id = F0u/
// module chunks = 1